import Cross from "../../../assets/icon/NewsIcons/MainAdmin/NewsCross";
import React from "react";

const STATUS_LABELS = {
    Draft: "پیش‌نویس",
    Sent: "ارسال شده",
    Interview: "مصاحبه",
    Offer: "پیشنهاد",
    Rejected: "رد شده",
};

const DetailJobApplyModal = ({ setShowModal, data }) => {
    return (
        <>
            <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
                <div className="relative w-[50%] my-5 mx-auto ">
                    <div className="border-0 rounded-[20px] p-[25px] shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                        <div className="flex justify-between items-center border-b-2 pb-[25px] border-borderGray">
                            <p className="text-[15px] font-IRANYekanBold text-mainColor2">جزئیات درخواست</p>
                            <button onClick={() => setShowModal(false)} aria-label="Close">
                                <Cross />
                            </button>
                        </div>

                        <div className="w-full mt-[23px] mb-[43px] max-h-[55vh] overflow-y-auto text-[13px] text-mainColor2">
                            <p><b>موضوع:</b> {data.subject || "—"}</p>
                            <p className="mt-2"><b>شغل:</b> {data.job?.title || "—"}</p>
                            <p className="mt-2"><b>شرکت:</b> {data.job?.company || "—"}</p>
                            <p className="mt-2"><b>ایمیل تماس:</b> {data.job?.contactEmail || "—"}</p>
                            <p className="mt-2"><b>کاربر:</b> {data.userName} {data.userFamily} ({data.userEmail})</p>
                            <p className="mt-2"><b>وضعیت:</b> {data.statusLabel || STATUS_LABELS[data.status] || data.status}</p>
                            <p className="mt-2"><b>تاریخ ارسال:</b> {data.sentAt ? new Date(data.sentAt).toLocaleString("en-GB") : "—"}</p>
                            <p className="mt-2"><b>تاریخ ایجاد:</b> {data.createdAt ? new Date(data.createdAt).toLocaleString("en-GB") : "—"}</p>
                            <p className="mt-2"><b>پیوست‌ها:</b> {data.attachments && data.attachments.length > 0 ? data.attachments.map((a) => a.fileName).join(", ") : "—"}</p>
                            {data.coverLetter ? (
                                <div className="mt-3">
                                    <p className="mb-1"><b>متن ایمیل:</b></p>
                                    <div className="rounded-[10px] border border-borderGray p-[10px]" dangerouslySetInnerHTML={{ __html: data.coverLetter }} />
                                </div>
                            ) : null}
                        </div>

                        <div className="flex justify-center">
                            <button onClick={() => setShowModal(false)} className="h-[40px] w-[107px] bg-infinity-gradient rounded-[10px]">
                                <p className="text-[15px] text-white font-IRANYekanBold">بستن</p>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
        </>
    );
};

export default DetailJobApplyModal;